import common from '../index.module.scss';
import app from '@frontend/application-container';
import { img } from '@phi/components';
import { SettingsEntrySingleLine } from '../settings-entry';
import { BackgroundsIcon } from '..';
import { h } from 'vue';
import { Flex } from '@phi/components/layout';
import { Environment } from '@frontend/Colours';

const reflectionbokeh_png = 'img/reflectionbokeh.png';
const reflectioncolors_png = 'img/reflectioncolors.png';
const reflectionblack_png = 'img/reflectionblack.png';

export function EnvironmentPicker() {
    return SettingsEntrySingleLine(
        'Scene environment',

        undefined,

        img(BackgroundsIcon, 'Scene environment'),

        h(Flex, { direction: 'row', gap: 'tight' }, () => [
            h('button', {
                title: 'Bokeh',
                type: 'button',
                class: {
                    btn: true,
                    [common.image_button]: true,
                    [common.active]: app.settings.environment === Environment.bokeh,
                },
                'data-toggle': 'popover',
                'data-html': true,
                'data-tippy-placement': 'top',
                'data-content': 'Bokeh environment.',
                onClick: () => app.settings.environment = Environment.bokeh,
            }, img(reflectionbokeh_png)),

            h('button', {
                title: 'Colors',
                type: 'button',
                class: {
                    btn: true,
                    [common.image_button]: true,
                    [common.active]: app.settings.environment === Environment.colors,
                },
                'data-toggle': 'popover',
                'data-html': true,
                'data-tippy-placement': 'top',
                'data-content': 'Colors environment.',
                onClick: () => app.settings.environment = Environment.colors,
            }, img(reflectioncolors_png)),

            h('button', {
                title: 'Black',
                type: 'button',
                class: {
                    btn: true,
                    [common.image_button]: true,
                    [common.active]: app.settings.environment === Environment.black,
                },
                'data-toggle': 'popover',
                'data-html': true,
                'data-tippy-placement': 'top',
                'data-content': 'Black environment.',
                onClick: () => app.settings.environment = Environment.black,
            }, img(reflectionblack_png)),
        ]),
    );
}
